class TrendyolScroll extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-trendyol-track]');
    if (!this.track) return;

    this.prevBtn = this.querySelector('[data-scroll-prev]');
    this.nextBtn = this.querySelector('[data-scroll-next]');

    this._onPrev = () => this.scrollByDir(-1);
    this._onNext = () => this.scrollByDir(1);
    this._onPause = () => this.pause();

    this.prevBtn?.addEventListener('click', this._onPrev);
    this.nextBtn?.addEventListener('click', this._onNext);

    if (this.dataset.scrollActive === 'true') {
      requestAnimationFrame(() => this.scrollActiveIntoView());
    }

    if (this.dataset.autoplay !== 'true') return;

    this.speed = (parseInt(this.dataset.speed, 10) || 3) * 1000;
    this._interval = setInterval(() => this.step(), this.speed);
    this.track.addEventListener('pointerdown', this._onPause);
    this.track.addEventListener('touchstart', this._onPause, { passive: true });
  }

  scrollByDir(direction) {
    const item = this.track.querySelector('[data-trendyol-item], .header-trendyol-nav__link, .trendyol-categories__item');
    if (!item) return;

    const gap = parseFloat(getComputedStyle(this.track).gap) || 12;
    const scrollStep = (item.offsetWidth + gap) * 2;
    this.track.scrollBy({ left: scrollStep * direction, behavior: 'smooth' });
  }

  scrollActiveIntoView() {
    const active = this.track.querySelector(
      '.trendyol-categories__item--active, .header-trendyol-nav__link--active'
    );
    if (!active) return;

    const trackRect = this.track.getBoundingClientRect();
    const activeRect = active.getBoundingClientRect();

    if (activeRect.left < trackRect.left || activeRect.right > trackRect.right) {
      active.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }
  }

  pause() {
    clearInterval(this._interval);
    this._interval = null;
  }

  step() {
    const item = this.track.querySelector('[data-trendyol-item], .header-trendyol-nav__link, .trendyol-categories__item');
    if (!item) return;

    const gap = parseFloat(getComputedStyle(this.track).gap) || 12;
    const scrollStep = item.offsetWidth + gap;
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;

    if (this.track.scrollLeft >= maxScroll - 2) {
      this.track.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      this.track.scrollBy({ left: scrollStep, behavior: 'smooth' });
    }
  }

  disconnectedCallback() {
    this.pause();
    this.prevBtn?.removeEventListener('click', this._onPrev);
    this.nextBtn?.removeEventListener('click', this._onNext);
    this.track?.removeEventListener('pointerdown', this._onPause);
    this.track?.removeEventListener('touchstart', this._onPause);
  }
}

if (!customElements.get('trendyol-scroll')) {
  customElements.define('trendyol-scroll', TrendyolScroll);
}
